/** The refine review page's other states: gone (expired, applied or not yours), failed, and no changes proposed. */

import { Link } from 'react-router-dom';
import { AlertTriangle, FileSearch, WandSparkles } from 'lucide-react';

import type { RefineProposalOut } from '@/api/types/refinements';
import { StateCard } from '@/ui/StateCard';

import { GapsCard } from '../files/ProposalNotices';

function Actions({ assetId, onRetry }: { assetId: string; onRetry?: () => void }) {
  return (
    <p className="empty-actions">
      {onRetry && (
        <button type="button" className="btn btn-secondary" onClick={onRetry}>
          <WandSparkles aria-hidden="true" /> Try again
        </button>
      )}
      <Link className="btn btn-ghost" to={`/assets/${assetId}`}>Back to the asset</Link>
    </p>
  );
}

export function RefinementGone({ assetId }: { assetId: string }) {
  return (
    <StateCard icon={<FileSearch aria-hidden="true" />} title="This refinement is no longer available">
      <p>A refinement is kept for 7 days until it is applied, and only the person who started it can open it.</p>
      <Actions assetId={assetId} />
    </StateCard>
  );
}

/** `reason` is the server's: a model error, or the AI budget refusing the call. */
export function RefinementFailed({ assetId, reason, onRetry }: { assetId: string; reason: string | null; onRetry?: () => void }) {
  return (
    <StateCard warning icon={<AlertTriangle aria-hidden="true" />} title="The refinement failed">
      <p role="alert">{reason || 'The refinement failed.'}</p>
      <Actions assetId={assetId} onRetry={onRetry} />
    </StateCard>
  );
}

export function NoChanges({ proposal, onRetry }: { proposal: RefineProposalOut; onRetry?: () => void }) {
  return (
    <div className="stack-md">
      <StateCard icon={<FileSearch aria-hidden="true" />} title="No changes proposed">
        <p>The AI found nothing to change for this instruction. The gaps below say what it missed.</p>
        <Actions assetId={proposal.asset_id} onRetry={onRetry} />
      </StateCard>
      <GapsCard gaps={proposal.gaps} id="refine-gaps-title" />
    </div>
  );
}
